



















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import date from "@/filters/DateFilter";
import datetime from "@/filters/DateTimeFilter";
import i18n from "@/lang/i18n";
import { SearchPaginationButton } from "../../model/component.model";
import { SearchExport } from "./SearchExport";

@Component({
  components: {}
})
export default class SearchPagination extends Vue {
  SearchExport: SearchExport = new SearchExport();

  @Prop({})
  onsearch: Function; // callback when doing a search update
  @Prop({})
  page: number; // current page number
  @Prop({})
  pagesize: number; // current pagesize number

  @Prop({})
  results: any[]; // results prop, used for len count
  @Prop({})
  pagination: any; // pagination object prop, used for total count
  @Prop({ default: false })
  showExportButton: boolean;
  @Prop({
    default: function() {
      return [];
    }
  })
  presetsForExport: any[]; //presets = [];
  @Prop({ default: "" })
  entityPrefix: string;
  @Prop({}) //{key: 'f1', label: 'ciao', icon: 'mbe-icon-export'}, {key: 'f2', label: 'mondo', icon: 'mbe-icon-copy'}
  customButtons: SearchPaginationButton[];
  @Prop({}) //{key: 'f1', label: 'ciao', icon: 'mbe-icon-export'}, {key: 'f2', label: 'mondo', icon: 'mbe-icon-copy'}
  persistentButtons: SearchPaginationButton[];
  @Prop({})
  hideSummary: boolean;
  // Experimental
  @Prop({ default: undefined })
  gettranslatedfieldnamecallback?: Function;
  @Prop({ default: true })
  sizeSelectable?: boolean;

  myPage = 1;
  myPageSize = 25;
  pageSizes: any[] = [];

  @Watch("myPage")
  onMyPageChanged(value: any) {
    this.$emit("update:page", this.myPage);
  }
  @Watch("myPageSize")
  onMyPageSizeChanged(value: any) {
    this.$emit("update:pagesize", this.myPageSize);
  }

  // watch original prop changing so update the internal state
  @Watch("page")
  onPageChanged(value: any) {
    this.myPage = value;
  }

  // watch original prop changing so update the internal state
  @Watch("pagesize")
  onPageSizeChanged(value: any) {
    this.myPageSize = value;
  }

  onCustomButtonPressed(item: any) {
    this.$emit("onCustomButtonPressed", item.key);
  }

  created() {
    this.myPage = this.page || 1;
    this.myPageSize = this.pagesize || 25;
    if (this.sizeSelectable) {
      this.pageSizes = [
        { label: String(this.myPageSize), value: this.myPageSize },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
        { label: "500", value: 500 },
        { label: "2000", value: 2000 }
      ];
    } else {
      this.pageSizes = [
        { label: String(this.myPageSize), value: this.myPageSize }
      ];
    }
  }

  changePageSize(pageSize: number) {
    this.myPage = 1;
    this.myPageSize = pageSize;
    this.$emit("update:page", this.myPage);
    this.$emit("update:pagesize", this.myPageSize);

    // callback
    //this.$emit('onpagesize', this.myPageSize);
    //this.$emit('onsearch', this.myPage);
    this.onsearch(this.myPage);
  }

  // translate data as in the page
  processData(rows: any[]) {
    const self: any = this;
    const processRow = function(r: any) {
      const map: any = {};
      const visibles: any[] = self.presetsVisible();
      for (let i = 0; i < visibles.length; i++) {
        const p = visibles[i];

        let fieldNew = p.field.replace(".", "_");
        if (self.entityPrefix != "")
          fieldNew = self.entityPrefix + "_" + fieldNew;

        let key: any = i18n.t(fieldNew);
        if (self.gettranslatedfieldnamecallback != undefined) {
          key = self.gettranslatedfieldnamecallback(p.field);
        }

        const value = self.filterColumnValueXlsx(
          self.getValueFromObject(r, p.field),
          p.type,
          p.typeSpec
        );
        map[key] = value;
      }
      return map;
    };
    const data: any = [];
    rows.forEach((r: any) => {
      data.push(processRow(r));
    });
    return data;
  }

  // filter columns values based on preset type for Xlsx extraction
  // typeSpec: can be null, is used on decimal presets to rappresent number of digits to format a column
  filterColumnValueXlsx(value: any, type: any, typeSpec: any) {
    if (type === "DECIMAL" || type === "CURRENCY") {
      return value;
    } else if (type === "DATE") {
      return date(value);
    } else if (type === "DATETIME") {
      return datetime(value);
    }
    return value;
  }

  presetsVisible() {
    return this.presetsForExport.filter((el: any) => {
      return el.visible;
    });
  }

  getValueFromObject(object: any, field: string) {
    // handle special expressions like:
    // "extraServices//[mbeBusinessId=1].extraServiceValue" are nested values as: extraServices:[{mbeBusinessId:1, extraServiceValue: 0}, ... ]
    if (field.indexOf("extraServices//") != -1) {
      const groups = /extraServices\/\/\[mbeBusinessId=([\d]+)\]\.extraServiceValue/.exec(
        field
      );
      if (groups && groups.length > 0) {
        if (object.extraServices && object.extraServices.length > 0) {
          const mbeBusinessId = parseInt(groups[1]);
          const a = object.extraServices.filter((el: any) => {
            return el.mbeBusinessId === mbeBusinessId;
          });
          if (a && a.length > 0) {
            return a[0].extraServiceValue;
          }
          return null;
        }
      }
      return null;
    }

    // handle localization of countries id
    if (field.indexOf(".countryId") != -1) {
      return i18n.t("country_" + field.split(".").reduce(index, object));
    }

    // handle localization of shipPackType Id
    if (field.indexOf("shipPackTypeId") != -1) {
      return i18n.t("mbePackageType_" + field.split(".").reduce(index, object));
    }

    // handle localization of salesTypeName string
    if (field.indexOf("salesTypeName") != -1) {
      return i18n.t("salesTypeName_" + field.split(".").reduce(index, object));
    }

    // handle localization of paymentType string
    if (field.indexOf("paymentType") != -1) {
      return i18n.t("paymentMethod_" + field.split(".").reduce(index, object));
    }

    if (field.indexOf("reminderLevel") != -1) {
      if (field.split(".").reduce(index, object) != null) {
        return i18n.t(
          "reminderLevel_" + field.split(".").reduce(index, object)
        );
      } else return "";
    }

    // ELSE
    function index(object: any, i: string) {
      if (!object) return null;
      // feat #2299: handle array fields
      if (Array.isArray(object)) {
        return object[0][i];
      }
      return object[i];
    }

    return field.split(".").reduce(index, object);
  }
}
